<template>
  <div class="container">
    <img class="main-top" src="../assets/img/logo.png" />
    <!-- <h1 class="start-title">대한제국 칙령41호</h1> -->
    <h1 class="start-title">황제의 친서</h1>
    <img class="start-img" src="../assets/img/mainimg.png">
    <router-link id="start" class="play-new button" to="/register">새 게임하기</router-link>
    <button id="start" class="play-old button" @click="login_toggle=true">이어하기</button>
    <login v-if="login_toggle" @close="login_toggle = false"></login>
    <div class="credit">
    <img src="../assets/img/splash_logo.png" />
    </div>
  </div>
</template>

<script>
import login from './Login.vue'
export default {
  data () {
    return {
      login_toggle: false
    }
  },
  components: {
    login
  }
}
</script>

<style scoped>
@font-face {
    font-family: 'GyeonggiBatang';
    src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_one@1.0/GyeonggiBatang.woff') format('woff');
    font-weight: normal;
    font-style: normal;
}
.main-bottom {
  width: 100%;
}
.main-top {
  width: 71.2%;
  margin: 0 14.4%;
  /* margin-bottom: 9rem; */
}
#start {
  border-radius: 0px;
  width: 80%;
  margin: 0 10%;
  margin-bottom: 2%;
}
h1.start-title{
  font-family: 'GyeonggiBatang';
  width: 100%;
  font-size: 2rem;
  text-align: center;
}
h1.start-title:nth-child(1){
  /* color:steelblue; */
  font-weight: 700;
}
h1.start-title:nth-child(2){
  /* color:green; */
  padding-bottom: 2rem;
}
.start-img{
  padding-bottom: 2rem;
}
.credit{
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.container{
  padding-top:40px;
}
</style>



// WEBPACK FOOTER //
// src/components/Door.vue